// 礼物剪影（EP-008-S5 / GDD 03 §②-2.4 / ⑧-C7/C8）。
// CSS mask-image 复用「同一张彩图」alpha（零额外资产文件）；background-color: var(--n3)（#C4B49F）。
// 不套 filter（保留 baked 星点/光粒轮廓，C8）；不发起额外图片请求（C7：仅复用 gift 图 URL）。
import { assetIndex, type AssetId } from '../assets/assetIndex';

interface SilhouetteProps {
  giftId: string;
}

export function Silhouette({ giftId }: SilhouetteProps) {
  const src = assetIndex[('gift_' + giftId) as AssetId];
  return (
    <div
      className="gift-silhouette"
      role="img"
      aria-label="尚未获得的礼物剪影"
      style={{
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
      }}
    />
  );
}
